import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/index';

@Injectable({
  providedIn: 'root',
})
export class LocaleSwitcherService {
  private translateService = inject(TranslateService);
  private router = inject(Router);

  multiLanguage = environment.multiLanguage;
  availableLanguages = environment.availableLanguages;
  currentLang = signal(
    this.translateService.currentLang || environment.defaultLanguage,
  );

  selectLang(lang: string) {
    let currentLang = this.translateService.currentLang;
    if (currentLang !== lang) {
      let newState = this.router.url;
      if (lang === environment.defaultLanguage) {
        newState = newState.replace(`/${currentLang}`, '');
      } else {
        currentLang = `/${currentLang}/`;
        if (newState.indexOf(currentLang) >= 0) {
          newState = newState.replace(currentLang, `/${lang}/`);
        } else {
          newState = `/${lang}${newState}`;
        }
      }

      const currentScrollTop = window.pageYOffset;
      this.translateService.use(lang);
      this.currentLang.set(lang);
      this.router
        .navigateByUrl(newState)
        .then(() => window.scrollTo({ top: currentScrollTop }));
    }
  }
}
